const { FormattedMessage } = require('react-intl');

const FlightFormatted = ({ flight, noLabel }) => (
  <>
    {!noLabel && (
      <>
        <FormattedMessage id="quoteDetail.flight" />
        :&nbsp;
      </>
    )}
    {flight?.airline}&nbsp;{flight?.flightNumber}
  </>
);

export default FlightFormatted;
